module.exports = __webpack_public_path__ + "img/Drone.867dee29.gif";